// A whole CNPJ typed in an org form's document box asks what the host knows of
// it (fire/docs/ORGBIZGOV.md § The prefill hook) and fills the BLANK boxes
// with it: a box somebody typed is never overwritten, a 404 changes nothing.
// On the <form>, listening for any input and acting on the document box only,
// so the address partial stays as it is; boxes are found by their name's end.
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { url: String };

  look({ target }) {
    if (!target.name?.endsWith('[doc]')) return;

    const digits = target.value.replace(/\D/g, '');
    if (digits.length !== 14 || digits === this.asked) return;

    this.asked = digits;
    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set('doc', digits);
    fetch(url, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((found) => found && this.fill(found))
      .catch(() => {});
  }

  fill(found) {
    ['name', 'nick', 'addr', 'num', 'hood', 'zip'].forEach((key) => {
      const box = this.element.querySelector(`[name$="[${key}]"]`);
      if (box && !box.value && found[key]) box.value = found[key];
    });

    // The city is a typeahead: its id box and its text box (fire/shared/_address).
    const id = this.element.querySelector('[data-cep-target="cityId"]');
    const text = this.element.querySelector('[data-cep-target="city"]');
    if (id && text && !id.value && found.city_id) {
      id.value = found.city_id;
      text.value = found.city;
    }
  }
}
